<template>
  <v-alert
    :class="
      `sistemos-pranesimas ${savitarna ? 'sistemos-pranesimas-savitarna' : ''}`
    "
    dense
    outlined
    type="error"
    v-if="isSistemaInfo"
  >
    <p class="sistemos-pranesimas-text" v-html="sistemaInfo"></p>
  </v-alert>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'ElSistemaInfo',
  props: {
    text: String,
    savitarna: Boolean,
  },
  computed: {
    ...mapGetters(['sistemaInfo']),
    isSistemaInfo() {
      return this.sistemaInfo
    },
    infoText() {
      return this.text ?? this.sistemaInfo
    },
  },
}
</script>

<style lang="scss">
.sistemos-pranesimas {
  margin-left: 12px;
  margin-right: 12px;
  margin-bottom: 0px;
  padding-top: 15px;
  background-color: white !important;
  font-size: 14px;

  &.sistemos-pranesimas-savitarna {
    margin-left: 0px;
    margin-right: 3px;
    margin-bottom: 20px;
    font-size: 13px;
  }
}
.sistemos-pranesimas-text {
  p {
    margin-bottom: 3px;
  }
}
</style>
